/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseContactList } from '../../models/api-response-contact-list';
import { ContactList } from '../../models/contact-list';

export interface UpdateContactList$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: ContactList
}

export function updateContactList(http: HttpClient, rootUrl: string, params: UpdateContactList$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseContactList>> {
  const rb = new RequestBuilder(rootUrl, updateContactList.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseContactList>;
    })
  );
}

updateContactList.PATH = '/v1/api/ui/contactList/{ref}';
